export const SportsApiEndpointsWithoutLoginPattern = new RegExp(
  '^(?!https?://(?:api-scouts.statscore.com|api.beta.statscore.com|dev.api.statscore.com)/v2/auth/login).*$',
)

// TODO: repeated as workaround in ...sportsapi/client/src/utils/utils.ts
export const SportsApiEndpoints = new RegExp(
  '(?!https?://(?:api-scouts.statscore.com|api.beta.statscore.com|dev.api.statscore.com)/).*$',
)
